import React from "react";
import { Link } from "react-router-dom";
// import Img
import Error from "../assets/png/error.png";
import LetterAnimation from "../shared/components/animations/LetterAnimation";
import ScrollAnimation from "../shared/components/animations/ScrollAnimation";
import TransitionPage from "../shared/components/animations/TransitionPage";
import Button from "../shared/components/Button";

const Notfound = () => {
  return (
    <section className="bg-[#F3FAFF] h-screen flex flex-col justify-center items-center">
      <TransitionPage />
      {/* div main */}
      <div className="flex flex-col items-center w-full">
        {/* div title */}
        <div
          className="flex flex-col items-center text-center"
          style={{
            backgroundImage: `url(${Error})`,
            backgroundSize: "contain", // Use contain to keep the image visible on all screens
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            width: "90%", // Ensure background stretches across screen width
            height: "50vh", // Adjusted height to ensure image is visible
          }}
        >
          <LetterAnimation
            delay={0.6}
            className="text-[96px] md:text-[150px] lg:text-[200px] text-[#0369A1] mt-20 lg:mt-28"
            text="404"
          />
          <ScrollAnimation delay={0.6}>
            <h2 className="text-black pt-9 lg:pt-0 text-xl md:text-2xl lg:text-3xl">
              La page que vous recherchez n’existe pas
            </h2>
          </ScrollAnimation>
        </div>
        {/* div link button */}
        <div className="mt-16 lg:mt-20 max-w-[400px] mx-auto">
          <ScrollAnimation delay={0.6}>
            <Link to="/">
              <Button
                className="text-white bg-[#F9CB4E] hover:bg-[#0369A1] transition-all py-3 px-8 rounded-lg text-base md:text-lg lg:text-xl"
                label="Retourner sur la page d’accueil"
              />
            </Link>
          </ScrollAnimation>
        </div>
      </div>
    </section>
  );
};

export default Notfound;
